<iframe #frame class="signature-preview__frame" [srcdoc]="frameDocument" [title]="label"
    sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer"
    (load)="onFrameLoad()"></iframe>
